import { defaultStylingSchema } from '../schema';

export const socialBlockSchemaEnhancer = ({ formData, schema, intl }) => {
  schema.fieldsets[1].fields = ['align', 'size'];
  schema.fieldsets = schema.fieldsets.filter((item) => item.id !== 'advanced');

  return defaultStylingSchema({ schema, formData, intl });
};
